import { isOpen } from '@/api/loin' //引入接口

async function checkIsOpen () {
  return await isOpen({type:1}).then(res => {
    console.log('开通够---', res)
    if (res.status == 200) {
      if ( res.content.is_open != 1 ) {//"is_open": 0, //1代表开通过拓客
        // 没有开通，跳转开通页面
        return true
      }
    }
    return false
  })
}

// 获取cookie
function getCookie (cname) {
  let name = cname + '='
  let ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') c = c.substring(1)
    if (c.indexOf(name) != -1) return c.substring(name.length, c.length)
  }
  return ''
}
//添加cookie
function setCookie (c_name, value, expiredays) {
  let exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  let path = '/'
  document.cookie =
    c_name +
    '=' +
    encodeURIComponent(value) +
    ';expires' +
    exdate.toGMTString() +
    ';path=' +
    path
}

//删除cookie
function delCookie (name) {
  let exp = new Date()
  let path = '/'
  exp.setTime(exp.getTime() - 1)
  let cval = getCookie(name)
  if (cval != null)
    document.cookie =
      name + '=' + cval + ';expires=' + exp.toGMTString() + ';path=' + path
}

let tokenId = ''

if (getCookie('SYB_TX[tokenId]') != '' || getCookie('SYB_TX[tokenId]')) {
  tokenId = getCookie('SYB_TX[tokenId]')
}

// 分享 c 端公共地址

export default {
  setCookie,
  delCookie,
  getCookie,
  tokenId,
  checkIsOpen
}
